// <s-back-to-top hidden>: reveals its button after one viewport of scrolling and returns focus to the
// skip-link target after scrolling to the top. Smooth scrolling only without reduced motion.
class BackToTop extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const update = () => { this.hidden = window.scrollY < window.innerHeight; };
    window.addEventListener('scroll', update, { passive: true, signal });
    update();
    this.querySelector('button')?.addEventListener('click', () => {
      const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: smooth ? 'smooth' : 'auto' });
      document.getElementById('main-content')?.focus({ preventScroll: true });
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }
}

if (!customElements.get('s-back-to-top')) customElements.define('s-back-to-top', BackToTop);
